import React from 'react'

import _modules from '../../_modules'

const ProductStocks = React.lazy(() => import('./views/productStocks/ProductStocks'))
const ProductStocksDetail = React.lazy(() => import('./views/productStocks/ProductStocksDetail'))
const InventorySettingsDetail = React.lazy(() =>
  import('./views/inventorySettings/InventorySettingsDetail'),
)

const _routes = []

if (_modules.product_stocks)
  _routes.push(
    ...[
      {
        path: '/product-stocks/:id',
        name: 'Product Stocks Detail',
        component: ProductStocksDetail,
      },
      { path: '/product-stocks', name: 'Product Stocks', component: ProductStocks },
    ],
  )
if (_modules.inventory_settings)
  _routes.push(
    ...[
      {
        path: '/inventory-settings',
        name: 'Inventory Setting',
        component: InventorySettingsDetail,
      },
    ],
  )

export default _routes
